import React, { useState, useEffect } from "react";
import { Button} from 'reactstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import "./banner.css";
import $ from 'jquery';
import { useNavigate } from 'react-router-dom';
import Test from './Test';

const common = require('../utils/Common');
const envConfig = require('../config/envConfig');

const Banner = () => {
  let navigate = useNavigate();
	const [logos, setlogos] = useState([]);
  const [banners, setBanners] = useState([]);
  const [brochure, setBrochure] = useState(null);
  const [serviceInstruction, setServiceInstruction] = useState(null);
  const [productInstruction, setProductInstruction] = useState(null);
  const [bannerUrl, setBannerUrl] = useState([]);
  const [logoUrl, setLogoUrl] = useState("");
  const [brochureUrl, setBrochureUrl] = useState(null);
  const [serviceInstructionUrl, setServiceInstructionUrl] = useState(null);
  const [productInstructionUrl, setProductInstructionUrl] = useState(null);
  const [cmsData, setCmsData] = useState({
    'about_us' : '',
    'contact_us' : '',
    'payments' : '',
    'shipping' : '',
    'cancellation_and_returns' : '',
    'faq' : '',
    'terms_of_use' : '',
    'security' : '',
    'privacy' : '',
    'legal_disclamer' : '',
    'terms_and_condition_seller' : '',
    'terms_and_condition_customer' : '',
    'terms_and_condition_account_delete' : ''
  });
  const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});

  useEffect(() => {
    checkAccess();
  },[]);

  const checkAccess = async () => {
    let rights = await common.checkAccessRights(window.location.pathname);
    if (!rights.view) {
      alert("Access Denied");
      navigate("/");
      return;
    } else {
      setUserRights(rights);
      if (!localStorage.getItem('admin_token')) {
        navigate('/login');
      }
      getCmsData();
    }
  }

  const getCmsData = async () => {
    var data = {
      'id' : 1
    };
    let response = await common.apiRequest('post', '/admin/get-cms-data', data);
		if (response.status == 200) {
			if (response.data.code == 'success') {
        if (response.data.cmsData.length > 0) {
          setCmsData(response.data.cmsData[0]);
          if (response.data.logoBannerData && response.data.logoBannerData.length > 0) {
            setLogoUrl(response.data.logoBannerData[0]['logo']);
            setBannerUrl(response.data.logoBannerData[0]['banners'].split(','));
            setBrochureUrl(response.data.logoBannerData[0]['brochure']);
            setProductInstructionUrl(response.data.logoBannerData[0]['product_instructions']);
            setServiceInstructionUrl(response.data.logoBannerData[0]['service_instructions']);
          }
          delete cmsData.created_at;
          delete cmsData.updated_at;
          delete cmsData.last_updated_by;
          delete cmsData.logo;
          delete cmsData.banners;
        }
			} else {
				$('#error').html(response.data.error);
			}
		} else {
			$('#error').html(response);
		}
  }

  function onImageChange(e, type) {
    if (type == "logo") {
      setlogos(e.target.files);
    } else if (type == "banners") {
      setBanners(e.target.files);
    } else if (type == "brochure") {
      setBrochure(e.target.files);
    } else if (type == "product_instructions") {
      setProductInstruction(e.target.files);
    } else if (type == "service_instructions") {
      setServiceInstruction(e.target.files);
    }
  }

 

  const handleChange = (e,editor,id)=>{
    cmsData[id] = editor.getData();
  }

  const saveCMSData = async () => {
    cmsData.last_updated_by = localStorage.getItem('admin_userId');
    let response = await common.apiRequest('post', '/admin/save-cms-data', cmsData);
    if (response.status == 200) {
      if (response.data.code == 'success') {
        if (!cmsData.id) {
          getCmsData();
        }
        alert('update');
        navigate('/cms');
      } else {
        alert('Something went wrong');
        navigate('/cms');
      }
    } else {
      alert('Something went wrong');
      navigate('/');
    }
  }

  const uploadLogo = async () => {
    var fileData = new FormData();
    fileData.append('logo', logos[0]);
    var response = await common.apiRequest('post', '/admin/update-logo', fileData);
    resetLogoAndBannerValues(response);
  }

  const uploadBanner = async () => {
    var fileData = new FormData();
    for (const key of Object.keys(banners)) {
      fileData.append('banners', banners[key]);
    }
    var response = await common.apiRequest('post', '/admin/update-banners', fileData);
    resetLogoAndBannerValues(response);
  }

  const uploadBrochureAndInstructions = async (type) => {
    var fileData = new FormData();
    if (type == "brochure") {
      for (const key of Object.keys(brochure)) {
        fileData.append(type, brochure[key]);
      }
    } else if (type == "product_instructions") {
      for (const key of Object.keys(productInstruction)) {
        fileData.append(type, productInstruction[key]);
      }
    } else if (type == "service_instructions") {
      for (const key of Object.keys(serviceInstruction)) {
        fileData.append(type, serviceInstruction[key]);
      }
    }
    var response = await common.apiRequest('post', '/admin/update-brochure-and-instructions', fileData);
    resetLogoAndBannerValues(response);
  }

  const resetLogoAndBannerValues = (response) => {
    if (response.data.logoBannerData && response.data.logoBannerData.length > 0) {
      setLogoUrl(response.data.logoBannerData[0]['logo']);
      setBannerUrl(response.data.logoBannerData[0]['banners'].split(','));
      setlogos([]);
      setBanners([]);
      $('#logo').val('');
      $('#banner').val('');
    } else {
      setBrochureUrl(response.data.data[0]['brochure']);
      setProductInstructionUrl(response.data.data[0]['product_instructions']);
      setServiceInstructionUrl(response.data.data[0]['service_instructions']);
      setBrochure([]);
      setProductInstruction([]);
      setServiceInstruction([]);
      $('#brochure').val('');
      $('#productInstruction').val('');
      $('#serviceInstruction').val('');
    }
  }

  const updateLogoBannerAndInstructions = (type) => {
    if (type == "logo") {
      uploadLogo();
    } else if (type == "banner") {
      uploadBanner();
    } else {
      uploadBrochureAndInstructions(type);
    }
  }
  const [receivedPhotoLink, setReceivedPhotoLink] = useState('');
  const handlePhotoLinkReceived = (photoLink) => {
    setReceivedPhotoLink(photoLink);
  };


  return ( 
	<>
  <div className="" style={{ backgroundColor: '#D3D3D3'}}>
  <div className="container" >
    <section className="section">
      <h1 className="headder1">logo Upload</h1>
      <div className="photos">
        <img src={envConfig.api_url + logoUrl} alt="Logo" width={"250px"} />
      </div>
      <div className="banner">
        <div className="center">
          <input type="file" id="logo" accept="image/*" onChange={(e) => {onImageChange(e, 'logo')}} />
            {
              logos.length > 0 ? <Button type='button' className='submit-button' onClick={() => {updateLogoBannerAndInstructions('logo')}}>Submit</Button> : "Select Image"
            }
        </div>
      </div>
    </section>
    <section className="section">
      <h1 className="headder1">Banner Upload</h1>
        <div className="photos">
              {bannerUrl.map((imageSrc) => (
                <img src={envConfig.api_url + imageSrc} alt="Banners" width={"250px"} />
              ))}
        </div>
        <div className="banner">
          <div className="center">
            <input type="file" id="bannner" multiple accept="image/*" onChange={(e) => {onImageChange(e, 'banners')}} />
            {
                banners.length > 0 ? <Button type='button' className='submit-button' onClick={() => {updateLogoBannerAndInstructions('banner')}}>Submit</Button> : "Select Image"
              }
          </div>
        </div>
    </section>
    {/* Brochure */}
    <section className="section">
      <h1 className="headder1">Brochure</h1>
      <div className="photos">
        {brochureUrl ? (
          <a
            href={envConfig.api_url + brochureUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button color="primary">View Brochure</Button>
          </a>
        ) : (
          <p>No brochure uploaded</p>
        )}
      </div>
      <div className="banner">
        <div className="center">
          <input
            type="file"
            id="brochure"
            accept="application/pdf"
            onChange={(e) => onImageChange(e, "brochure")}
          />
          {brochure ? (
            <Button
              type="button"
              className="submit-button"
              onClick={() => updateLogoBannerAndInstructions("brochure")}
            >
              Submit
            </Button>
          ) : (
            "Select PDF"
          )}
        </div>
      </div>
    </section>

    {/* Service Instructions */}
    <section className="section">
      <h1 className="headder1">Service Instructions</h1>
      <div className="photos">
        {serviceInstructionUrl ? (
          <a
            href={envConfig.api_url + serviceInstructionUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button color="primary">View Service Instructions</Button>
          </a>
        ) : (
          <p>No service instructions uploaded</p>
        )}
      </div>
      <div className="banner">
        <div className="center">
          <input
            type="file"
            id="serviceInstruction"
            accept="application/pdf"
            onChange={(e) => onImageChange(e, "service_instructions")}
          />
          {serviceInstruction ? (
            <Button
              type="button"
              className="submit-button"
              onClick={() =>
                updateLogoBannerAndInstructions("service_instructions")
              }
            >
              Submit
            </Button>
          ) : (
            "Select PDF"
          )}
        </div>
      </div>
    </section>

    {/* Product Instructions */}
    <section className="section">
      <h1 className="headder1">Product Instructions</h1>
      <div className="photos">
        {productInstructionUrl ? (
          <a
            href={envConfig.api_url + productInstructionUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button color="primary">View Product Instructions</Button>
          </a>
        ) : (
          <p>No product instructions uploaded</p>
        )}
      </div>
      <div className="banner">
        <div className="center">
          <input
            type="file"
            id="productInstruction"
            accept="application/pdf"
            onChange={(e) => onImageChange(e, "product_instructions")}
          />
          {productInstruction ? (
            <Button
              type="button"
              className="submit-button"
              onClick={() =>
                updateLogoBannerAndInstructions("product_instructions")
              }
            >
              Submit
            </Button>
          ) : (
            "Select PDF"
          )}
        </div>
      </div>
    </section>
    <section className="section">
      <h1 className="headder1">T&C Form</h1>
      <div className="textarea-container">
        <label htmlFor="custom-textarea" className="textarea-label">About us:</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'about_us')}} data={cmsData && cmsData.about_us ? cmsData.about_us : ''}/>
        <label htmlFor="custom-textarea" className="textarea-label">Contact us:</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'contact_us')}} data={cmsData.contact_us ? cmsData.contact_us : ''}/>
      </div>
      <div className="textarea-container">
        <label htmlFor="custom-textarea" className="textarea-label">Payments:</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'payments')}} data={cmsData.payments ? cmsData.payments : ''}/>
        <label htmlFor="custom-textarea" className="textarea-label">Shipping:</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'shipping')}} data={cmsData.shipping ? cmsData.shipping : ''}/>
        <label htmlFor="custom-textarea" className="textarea-label">Cancellation & Return:</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'cancellation_and_returns')}} data={cmsData.cancellation_and_returns ? cmsData.cancellation_and_returns : ''}/>
        <label htmlFor="custom-textarea" className="textarea-label">FAQ:</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'faq')}} data={cmsData.faq ? cmsData.faq : ''}/>
      </div>
      <div className="textarea-container">
        <label htmlFor="custom-textarea" className="textarea-label">Terms of use:</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'terms_of_use')}} data={cmsData.terms_of_use ? cmsData.terms_of_use : ''}/>
        <label htmlFor="custom-textarea" className="textarea-label">Security:</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'security')}} data={cmsData.security ? cmsData.security : ''}/>
        <label htmlFor="custom-textarea" className="textarea-label">Privacy:</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'privacy')}} data={cmsData.privacy ? cmsData.privacy : ''}/>
        <label htmlFor="custom-textarea" className="textarea-label">Legal Disclaimer:</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'legal_disclamer')}} data={cmsData.legal_disclamer ? cmsData.legal_disclamer : ''}/>
        <label htmlFor="custom-textarea" className="textarea-label">Terms & Condition (Customer):</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'terms_and_condition_customer')}} data={cmsData.terms_and_condition_customer ? cmsData.terms_and_condition_customer : ''}/>
        <label htmlFor="custom-textarea" className="textarea-label">Terms & Condition (Seller):</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'terms_and_condition_seller')}} data={cmsData.terms_and_condition_seller ? cmsData.terms_and_condition_seller : ''}/>
        <label htmlFor="custom-textarea" className="textarea-label">Terms & Condition (Account Delete):</label>
        <CKEditor editor={ClassicEditor} onChange={(e,editor)=>{handleChange(e,editor,'terms_and_condition_account_delete')}} data={cmsData.terms_and_condition_account_delete ? cmsData.terms_and_condition_account_delete : ''}/>
      </div>
    </section>
    {
      userRights.create && <center><button className="btn btn-primary" onClick={saveCMSData}>Save</button></center>
    }
  </div>
  </div>
 
   
  </>
  )
}

export default Banner
